import type {
  AssetStatDisaggregation,
  AssetStatFunction,
} from '../types/assetStats';
import type {ApiQueryParams} from '@/types/api';

export const assetKeys = {
  all: ['asset'] as const,

  lists: () => [...assetKeys.all, 'list'] as const,
  list: (filters: ApiQueryParams<{siteId: string; userId: string}> = {}) =>
    [...assetKeys.lists(), filters] as const,

  details: () => [...assetKeys.all, 'detail'] as const,
  detail: (id: string) => [...assetKeys.all, 'detail', id] as const,

  stats: (filters: {
    assetId: string;
    type: AssetStatFunction;
    disaggregation: AssetStatDisaggregation | string;
    categoryIds: string[] | undefined;
    sectionIds: string[] | undefined;
    tagIds: string[] | undefined;
  }) => [...assetKeys.all, 'stats', filters] as const,

  layout: (id: string) => [...assetKeys.all, 'layout', id] as const,
};
